"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var money_1 = require("../money");
function offerSubtotal(offer, currency) {
    var priceAmountCents = money_1.parseAmount(offer.price, currency).amountCents;
    var quantity = offer.quantity;
    var subtotalAmountCents = priceAmountCents * quantity;
    return money_1.parseAmountCents(subtotalAmountCents, currency);
}
exports.offerSubtotal = offerSubtotal;
function offerTotal(offer, currency) {
    var shippingPriceAmountCents = money_1.parseAmount(offer.shippingPrice, currency).amountCents;
    var subtotalAmountCents = offerSubtotal(offer, currency).amountCents;
    var totalAmountCents = subtotalAmountCents + shippingPriceAmountCents;
    return money_1.parseAmountCents(totalAmountCents, currency);
}
exports.offerTotal = offerTotal;
//# sourceMappingURL=offer_calculator.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/offers/offer_calculator.js
// module id = AoTK
// module chunks = 20 21